<template>
    <div class="container mx-auto bg-gray-200 p-3 pt-2 md:p-4 rounded-lg mb-8 md:mb-12">
        <!-- I wish this would... -->
        <h1 class="font-bold pt-1 lg:mx-5">Hi {{ displayName }}!</h1>
        <span
            v-if="value2 == 0"
            class="block mb-2 lg:m-5 text-xl"
        >
            Start with entering your <strong>current Balance</strong> and then add some payments.
        </span>

        <!-- Two columns -->
        <div class="flex flex-wrap md:flex-no-wrap mb-4 lg:mx-4">
            <div class="w-full md:w-3/12 lg:w-1/12 mb-5">
                <MonthsList :paymentsList="paymentsList"/>
            </div>
            <div class="w-full md:w-10/12 lg:w-11/12  md:mx-5">
                <div class="flex flex-col md:flex-row justify-between my-1">
                    <div class="flex flex-row my-1 order-2 md:order-1">
                        <button
                            data-cy="buttonAddOne"
                            :class="[paymentsList.length > 0 || value2 == 0 ? 'bg-blue-600' : 'bg-orange-500']"
                            class="flex-grow md:flex-grow-0 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded-l-lg"
                            @click="togglePayment('add')"
                        >
                            Add payment
                        </button>
                        <button
                            class="cursor-not-allowed flex-grow md:flex-grow-0 bg-blue-600 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded-r-lg"
                        >
                            <div class="flex items-center flex-shrink-0 text-white">
                                <span class="mr-2">Add recurring</span>
                                <svg class="bi bi-arrow-repeat font-bold" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M2.854 7.146a.5.5 0 00-.708 0l-2 2a.5.5 0 10.708.708L2.5 8.207l1.646 1.647a.5.5 0 00.708-.708l-2-2zm13-1a.5.5 0 00-.708 0L13.5 7.793l-1.646-1.647a.5.5 0 00-.708.708l2 2a.5.5 0 00.708 0l2-2a.5.5 0 000-.708z" clip-rule="evenodd"/>
                                    <path fill-rule="evenodd" d="M8 3a4.995 4.995 0 00-4.192 2.273.5.5 0 01-.837-.546A6 6 0 0114 8a.5.5 0 01-1.001 0 5 5 0 00-5-5zM2.5 7.5A.5.5 0 013 8a5 5 0 009.192 2.727.5.5 0 11.837.546A6 6 0 012 8a.5.5 0 01.501-.5z" clip-rule="evenodd"/>
                                </svg>
                            </div>
                        </button>
                    </div>
                    <Current class="order-1 md:order-2"/>
                </div>
                <!-- {{ paymentsList }} -->
                <div
                    id="paymentsWrapper"
                >
                    <div class="flex flex-col"
                        v-for="(payment, i) in paymentsList" :key="i"
                    >
                        <div
                            v-if="payment.month"
                            :id="payment.monthYearValue"
                            data-cy="listMonths"
                            class="text-xl font-medium border-b-2 my-3 md:mb-0 border-gray-500">
                            <span> {{ payment.monthValue }}</span>
                            <span class="md:hidden">, {{ payment.yearValue }}</span>
                        </div>
                        <div
                            v-else
                            data-cy="listPayments"
                            class="flex flex-col md:flex-row max-w-full">
                            <button
                                data-cy="rowPayment"
                                @click="togglePayment('update', payment)"
                                :class="[
                                    payment.amount > 0 ? 'bgGreen text-white' : 'bgRed text-white',
                                    'flex-1 font-normal rounded-t-lg md:rounded-none md:rounded-l-lg p-2 md:my-2']">
                                <div class="flex">
                                    <span class="flex-grow-0 hidden md:inline">{{ payment.date | dateFormat }}</span>
                                    <span class="flex-grow-0 inline md:hidden">{{ payment.date | dateFormatDM }}</span>
                                    <span class="flex-grow text-left pl-4">{{ payment.text }}</span>
                                    <span class="flex items-center justify-center flex-shrink-0">
                                        <span class="flex-grow-0 mr-3">{{ payment.amount | eur }}</span>
                                        <svg
                                            @click.stop="deletePayment(payment)"
                                            class="bi bi-trash-fill"
                                            data-cy="deletePayment"
                                            width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M2.5 1a1 1 0 00-1 1v1a1 1 0 001 1H3v9a2 2 0 002 2h6a2 2 0 002-2V4h.5a1 1 0 001-1V2a1 1 0 00-1-1H10a1 1 0 00-1-1H7a1 1 0 00-1 1H2.5zm3 4a.5.5 0 01.5.5v7a.5.5 0 01-1 0v-7a.5.5 0 01.5-.5zM8 5a.5.5 0 01.5.5v7a.5.5 0 01-1 0v-7A.5.5 0 018 5zm3 .5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7z" clip-rule="evenodd"/>
                                        </svg>
                                    </span>
                                </div>
                            </button>
                            <div
                                data-cy="cum"
                                :class="[
                                    payment.kum > 0 ? 'bg-green-500' : 'bg-red-500',
                                    'runningSaldo font-semibold text-center md:text-right md:font-normal rounded-b-lg md:rounded-none md:rounded-r-lg p-2 mb-3 md:my-2']"
                                style="color: #ecf0f1;"
                            >
                                <span class="mr-2 font-bold">{{ payment.kum | eur }}</span>
                                <!-- <svg class="bi bi-trash" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"/>
                                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" clip-rule="evenodd"/>
                                </svg> -->
                                <!-- <svg class="bi bi-x-circle" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z" clip-rule="evenodd"/>
                                    <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 010 .708l-7 7a.5.5 0 01-.708-.708l7-7a.5.5 0 01.708 0z" clip-rule="evenodd"/>
                                    <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 000 .708l7 7a.5.5 0 00.708-.708l-7-7a.5.5 0 00-.708 0z" clip-rule="evenodd"/>
                                </svg> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalSinglePayment />
    </div>
</template>

<script>
// import { db } from '@/db.js';
// import { db, serverTimestamp } from '@/db.js';
// import { db, timestamp } from '@/db.js';
import dayjs from 'dayjs';
import currency from 'currency.js';
import { mapFields } from 'vuex-map-fields';
import ModalSinglePayment from '@/components/payments/ModalSinglePayment.vue';
import Current from '@/components/payments/Current.vue';
import MonthsList from '@/components/payments/MonthsList.vue';


export default {
    name: 'Payments',
    components: {
        ModalSinglePayment,
        Current,
        MonthsList,
    },
    data() {
        return {
            payments: [],
            // modalAction: 'add',
        };
    },
    computed: {
        ...mapFields([
            // 'current.value',
            'paymentsRef',
            'user.uid',
            'user.displayName',
            'payment',
        ]),
        ...mapFields({
            value2: 'current.value_',
        }),
        paymentsList() {
            const array = [];
            let actualMonth = '';
            // console.log('this.value:', this.value2);
            if (this.payments.length > 0) {
                let kumValue = this.value2 || 0;
                for (let index = 0; index < this.payments.length; index += 1) {
                    if (actualMonth !== dayjs(this.payments[index].date).format('MMMM')) {
                        actualMonth = dayjs(this.payments[index].date).format('MMMM');
                        array.push({
                            month: true,
                            monthValue: actualMonth,
                            yearValue: dayjs(this.payments[index].date).format('YYYY'),
                            monthYearValue: actualMonth + dayjs(this.payments[index].date).format('YYYY'),
                        });
                    }
                    kumValue = currency(kumValue).add(this.payments[index].amount);
                    array.push({
                        date: this.payments[index].date,
                        text: this.payments[index].text,
                        amount: this.payments[index].amount,
                        kum: kumValue,
                        id: this.payments[index].id,
                    });
                }
            }
            return array;
        },
        // user() {
        //     // console.log('User:', this.$store.state.user);
        //     return this.$store.state.user;
        // },
    },
    beforeCreate() {
        this.$store.dispatch('getUserId');
        this.$store.dispatch('getPaymentRef')
            .then(ref => {
                // console.log('ref:', ref);
                this.$bind('payments',
                    ref.collection('list')
                        .where('date', '>=', dayjs().format('YYYY-MM-DD'))
                        .orderBy('date'));
            });
        // this.$store.dispatch('bindCurrent');
    },
    created() {
    },
    methods: {
        deletePayment(payment) {
            this.paymentsRef.collection('list').doc(payment.id).delete();
        },
        togglePayment(action = '', payment) {
            this.$store.commit('SET_SINGLEPAYMENT_MODAL', {
                open: !this.spModal,
                action,
            });
            // this.modalAction = action;
            if (payment.id.length > 0) {
                this.$store.commit('CLEAR_PAYMENT');
                const index = this.payments.findIndex(x => x.id === payment.id);
                this.$store.commit('SET_PAYMENT', this.payments[index]);
            }
        },
    },
};
</script>

<style scoped>
.runningSaldo {
    min-width: 10rem;
}

.text-greeen {
    color: #27372a;
}
.text-greeey {
    color: #210d0a;
}
.lighter {
    opacity: 0.15;
}
.bgGreen {
    background-color: rgba(46, 204, 113, .80);
}
.bgRed {
    background-color: rgba(202,55,42, 0.8)
}

</style>
